<template>
	<div>
		<div class="row">
			<div class="col-sm-3 text-right">
				Субъект РФ
			</div>
			<div class="col-sm-9">
				<select @change='changeRegion' v-model="selectedRegion" class='form-control my-control' :disabled='disabledRegion'>
					<option v-for="option in regions_list" :value='option.id'>
						{{ option.name }}
					</option>
				</select>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-3 text-right">
				Лесничество
			</div>
			<div class="col-sm-7 no-right-padding">
				<select @change='changeForestrie' v-model="selectedForestrie" class='form-control my-control' :disabled='disabledForestrie'>
					<option v-for="option in forestries_list" :value='option.id'>
						{{ option.name }}
					</option>
				</select>
			</div>
			<div class="col-sm-2 action_icons">
				<i style='margin-right: 10px' class='fas fa-pencil-alt' @click='editForestrie' :class='{disabled: disabledForestrie || selectedForestrie == 0}'></i>
				<i class='fa fa-plus' @click='addForestrie' :class='{disabled: disabledRegion}'></i>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-3 text-right">
				Уч. лесничество
			</div>
			<div class="col-sm-7 no-right-padding">
				<select @change='changeLocalforestrie' v-model="selectedLocalforestrie" class='form-control my-control' :disabled='disabledLocalforestrie'>
					<option v-for="option in localforestries_list" :value='option.id'>
						{{ option.name }}
					</option>
				</select>
			</div>
			<div class="col-sm-2 action_icons">
				<i style='margin-right: 10px' class='fas fa-pencil-alt' @click='editLocalForestrie' :class='{disabled: disabledLocalforestrie || selectedLocalforestrie == 0}'></i>
				<i class='fa fa-plus' @click='addLocalForestrie' :class='{disabled: disabledForestrie}'></i>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-3 text-right">
				Подлесничество
			</div>
			<div class="col-sm-7 no-right-padding">
				<select @change='changeSubforestrie' v-model="selectedSubForestrie" class='form-control my-control' :disabled='disabledSubforestrie'>
					<option v-for="option in subforestries_list" :value='option.id'>
						{{ option.name }}
					</option>
				</select>
			</div>
			<div class="col-sm-2 action_icons">
				<i style='margin-right: 10px' class='fas fa-pencil-alt' @click='editSubForestrie' :class='{disabled: disabledSubforestrie || selectedSubForestrie == 0}'></i>
				<i class='fa fa-plus' @click='addSubForestrie' :class='{disabled: disabledLocalforestrie}'></i>
			</div>
		</div>

		<modal v-model="displayModal" :backdrop='false' effect="fade" width='400px' style='overflow: visible;'>
			<div slot="modal-header" class="modal-header">
			    <h3 class="modal-title" style='font-size: 22px;'>
			    	{{ modalTitle }}
			    </h3>
			  </div>
			<div>
				<input type="text" placeholder="Введите название..." class="form-control" v-model="newName" style='font-size: 14px;' @keydown.enter='modalCallback'>
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-default" @click='displayModal = false'>Отмена</button>
				<button type="button" class="btn btn-success" @click='modalCallback' :disabled='!newName.length'>Сохранить</button>
			</div>
		</modal>

	</div>
</template>

<script>
	import {DB} from '@/constants'
	import { modal } from 'vue-strap'
	const REGION = 'region_list.php'
	const FORESTRIES = 'forestries_list.php'
	const LOCALFORESTRIES = 'localforestries_list.php'
	const SUBFORESTRIES = 'subforestries_list.php'

	const EDIT_FORESTRY = 'edit_forestry.php'
	const ADD_FORESTRY = 'add_forestry.php'
	const EDIT_LOCALFORESTRY = 'edit_localforestry.php'
	const ADD_LOCALFORESTRY = 'add_localforestry.php'
	const EDIT_SUBFORESTRY = 'edit_subforestry.php'
	const ADD_SUBFORESTRY = 'add_subforestry.php'

	//import {EventBus} from '../../lib/EventBus'

	export default {
		name: 'editTerritoryCatalog',
		data: function () { 
			return {
				selectedRegion: '0',
				regions_list: [],

				selectedForestrie: '0',
				forestries_list: [],

				selectedLocalforestrie: '0',
				localforestries_list: [],

				selectedSubForestrie: '0',
				subforestries_list: [],

				blockRegionSelect: false,
				blockForestrieSelect: false,
				blockLocalforestrieSelect: false,
				blockSubforestrieSelect: false,

				popup_select: null,

				displayModal: false,
				modalTitle: '',
				newName: '',
				modalCallback: false
			}
		},
		components: {
			modal
		},
		computed: {
			disabledRegion () {
				return this.regions_list.length == 0 || this.blockRegionSelect
			},
			disabledForestrie () {
				return this.forestries_list.length == 0 || this.blockRegionSelect || this.blockForestrieSelect
			},
			disabledLocalforestrie () {
				return this.localforestries_list.length == 0 || this.blockRegionSelect || this.blockForestrieSelect || this.blockLocalforestrieSelect
			},
			disabledSubforestrie () {
				return this.subforestries_list.length == 0 || this.blockRegionSelect || this.blockForestrieSelect || this.blockLocalforestrieSelect || this.blockSubforestrieSelect
			}
		},
		methods: {
			editForestrie () {
				this.modalTitle = 'Редактирование лесничества'
				this.newName = this.forestries_list.find(e => {return e.id == this.selectedForestrie}).name
				this.displayModal = true
				this.modalCallback = () => {
					fetch(DB + EDIT_FORESTRY + '?id=' + this.selectedForestrie + '&name=' + this.newName, {credentials: 'include'})
					.then(res => res.json())
					.then(json => {
						if(json.error == null)
						{
							this.fillForestriesList(this.selectedForestrie)
							this.displayModal = false
						} else {
							console.warn(json.error)
						}
					})
					.catch(e => console.log(e))
				}
				//console.warn(this.modalCallback)
			},
			addForestrie () {
				this.modalTitle = 'Создание лесничества'
				this.newName = ''
				this.displayModal = true
				this.modalCallback = () => {
					fetch(DB + ADD_FORESTRY + '?id=' + this.selectedRegion + '&name=' + this.newName, {credentials: 'include'})
					.then(res => res.json())
					.then(json => {
						if(json.error == null)
						{
							this.fillForestriesList(json.id)
							this.displayModal = false
						} else {
							console.warn(json.error)
						}
					})
					.catch(e => console.log(e))
				}
			},
			editLocalForestrie () {
				this.modalTitle = 'Редактирование участкового лесничества'
				this.newName = this.localforestries_list.find(e => {return e.id == this.selectedLocalforestrie}).name
				this.displayModal = true
				this.modalCallback = () => {
					fetch(DB + EDIT_LOCALFORESTRY + '?id=' + this.selectedLocalforestrie + '&name=' + this.newName, {credentials: 'include'})
					.then(res => res.json())
					.then(json => {
						if(json.error == null)
						{
							this.fillLocalForestriesList(this.selectedLocalForestrie)
							this.displayModal = false
						} else {
							console.warn(json.error)
						}
					})
					.catch(e => console.log(e))
				}
				//console.warn(this.modalCallback)
			},
			addLocalForestrie () {
				this.modalTitle = 'Создание участкового лесничества'
				this.newName = ''
				this.displayModal = true
				this.modalCallback = () => {
					fetch(DB + ADD_LOCALFORESTRY + '?id=' + this.selectedForestrie + '&name=' + this.newName, {credentials: 'include'})
					.then(res => res.json())
					.then(json => {
						if(json.error == null)
						{
							this.fillLocalForestriesList(json.id)
							this.displayModal = false
						} else {
							console.warn(json.error)
						}
					})
					.catch(e => console.log(e))
				}
			},
			editSubForestrie () {
				this.modalTitle = 'Редактирование подлесничества'
				this.newName = this.subforestries_list.find(e => {return e.id == this.selectedSubForestrie}).name
				this.displayModal = true
				this.modalCallback = () => {
					fetch(DB + EDIT_SUBFORESTRY + '?id=' + this.selectedSubForestrie + '&name=' + this.newName, {credentials: 'include'})
					.then(res => res.json())
					.then(json => {
						if(json.error == null)
						{
							this.fillSubForestriesList(this.selectedSubForestrie)
							this.displayModal = false
						} else {
							console.warn(json.error)
						}
					})
					.catch(e => console.log(e))
				}
			},
			addSubForestrie () {
				this.modalTitle = 'Создание подлесничества'
				this.newName = ''
				this.displayModal = true
				this.modalCallback = () => {
					fetch(DB + ADD_SUBFORESTRY + '?id=' + this.selectedLocalforestrie + '&name=' + this.newName, {credentials: 'include'})
					.then(res => res.json())
					.then(json => {
						if(json.error == null)
						{
							this.fillSubForestriesList(json.id)
							this.displayModal = false
						} else {
							console.warn(json.error)
						}
					})
					.catch(e => console.log(e))
				}
			},


			/*removePopup () {
				const old_element = document.querySelector('.context_popup')
				if(old_element)
					old_element.parentNode.removeChild(old_element)
			},
			bodyClick (evt) {
				this.removePopup()
			},
			buttonClick (evt) {
				let search_id, search_array
				switch (this.popup_select)
				{
					case 'region':
						search_id = this.selectedRegion
						search_array = this.regions_list
						break
					case 'forestry':
						search_id = this.selectedForestrie
						search_array = this.forestries_list
						break
					case 'localforestry':
						search_id = this.selectedLocalforestrie
						search_array = this.localforestries_list
						break
					case 'subforestry':
						search_id = this.selectedSubForestrie
						search_array = this.subforestries_list
						break
				}
				const found = search_array.find(e => {return e.id == search_id})
				if(!navigator.clipboard)
					fallbackCopyTextToClipboard(found.name)
				else
					navigator.clipboard.writeText(found.name)
				this.removePopup()
			},
			createPopup (evt) {
				this.removePopup()
				let popup = document.createElement('div')
				let button = document.createElement('button')
				button.innerHTML = 'Копировать значение'
				button.onclick = this.buttonClick

				popup.classList.add('context_popup')
				popup.appendChild(button)
				popup.style.display = 'block';
				popup.style.left = evt.clientX + 'px'
				popup.style.top = evt.clientY + 'px'

				document.querySelector('body').appendChild(popup)
			},
			contextMenu (evt, select) {
				//this.popup_select = select
				//this.createPopup(evt)
			},
			drop () {
				this.selectedRegion = this.regions_list[0].id
				this.changeRegion()
			},*/
			fillRegionsList () {
				this.blockRegionSelect = true
				fetch(DB + REGION, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.regions_list = data
						this.selectedRegion = this.regions_list[0].id
						if(this.selectedRegion)
							this.changeRegion()
						this.blockRegionSelect = false
					}
					else {
						this.regions_list = []
					}
				})
				.catch(err => console.log(err))
			},
			fillForestriesList (select) {
				this.blockForestrieSelect = true
				fetch(DB + FORESTRIES + '?id=' + this.selectedRegion, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.forestries_list = data
						this.selectedForestrie = select ? select : this.forestries_list[0].id
						if(this.selectedForestrie)
							this.changeForestrie()
						this.blockForestrieSelect = false
					}
					else {
						this.forestries_list = []
						this.localforestries_list = []
						this.subforestries_list = []
					}
				})
				.catch(err => console.log(err))
			},
			fillLocalForestriesList (select) {
				this.blockLocalforestrieSelect = true
				fetch(DB + LOCALFORESTRIES + '?id=' + this.selectedForestrie, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.localforestries_list = data
						this.selectedLocalforestrie = select ? select : this.localforestries_list[0].id
						if(this.selectedLocalforestrie)
							this.changeLocalforestrie()
						this.blockLocalforestrieSelect = false
					}
					else {
						this.localforestries_list = []
						this.subforestries_list = []
					}
				})
				.catch(err => console.log(err))
			},
			fillSubForestriesList (select) {
				this.blockSubforestrieSelect = true
				fetch(DB + SUBFORESTRIES + '?id=' + this.selectedLocalforestrie, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.subforestries_list = data
						this.selectedSubForestrie = select ? select : this.subforestries_list[0].id
						this.blockSubforestrieSelect = false
					}
					else {
						this.subforestries_list = []
					}
				})
				.catch(err => console.log(err))
			},
			changeRegion () {
				this.fillForestriesList()
				//EventBus.$emit(`change_region${this.$props.event_suffix}`, this.selected)
			},
			changeForestrie () {
				this.fillLocalForestriesList()
			},
			changeLocalforestrie () {
				this.fillSubForestriesList()
			},
			changeSubforestrie () {
				
			}
		},
		mounted () {
			/*
			EventBus.$on(`change_region_from_parent${this.$props.event_suffix}`, id => {
				this.selected = id
			})*/
			this.fillRegionsList()
			//document.querySelector('.modal-catalog').addEventListener('click', this.bodyClick, {capture: true})
		},
		beforeDestroy() {
			//if(document.querySelector('.modal-catalog'))
			//	document.querySelector('.modal-catalog').removeEventListener('click', this.bodyClick)
			//EventBus.$off(`change_region_from_parent${this.$props.event_suffix}`)
		}
	}
</script>

<style scoped>
	.no-right-padding {
		padding-right: 0;
	}

	.action_icons {
		text-align: right;
		display: flex;
    	justify-content: space-evenly;
	}

	.action_icons i {
		cursor: pointer;
		font-size: 20px;
		vertical-align: middle;
	}

	.action_icons i.disabled {
		color: #c7c7c7;
		cursor: default; 
	}

	.my-control {
		padding: 0 12px;
	}
</style>


// WEBPACK FOOTER //
// editTerritoryCatalog.vue?cbb5fb92